<template>
  <nav id="new-header" class="block md:hidden !bg-white !bg-opacity-90 !backdrop-blur-lg fixed w-full z-50 top-0 px-2 relative">
    <Container full-width-on-mobile>
      <div class="header-wrapper flex justify-between items-center">
        <!-- Start Left -->
        <NavLogo :href="Routes.get('root_url')">
          <span class="sr-only">remove.bg</span>
          <LogoRBG style="max-height: 60px;"/>
        </NavLogo>

        <div v-if="store.selectedImage !== null" class="flex custom-gap">
          <IconButton @mousedown="toggleCompareBefore" @mouseup="toggleCompareAfter" @touchstart="toggleCompareBefore" @touchend="toggleCompareAfter" variant="secondary"><CompareIcon :class="{ 'text-brand-typo': store.viewMode == ViewMode.Before, 'text-typo': store.viewMode == ViewMode.After }" /></IconButton>
          <IconButton variant="secondary" :disabled="!currentPersistentStore?.canUndo" @click="currentPersistentStore?.undo"><UndoIcon /></IconButton>
          <IconButton variant="secondary" :disabled="!currentPersistentStore?.canRedo" @click="currentPersistentStore?.redo"><RedoIcon /></IconButton>
        </div>
        <!-- End Left -->
      </div>
    </Container>
  </nav>
</template>

<script setup lang="ts">
import { NavLogo, IconButton, CompareIcon, Container, RedoIcon, UndoIcon, LogoRBG } from "prism";
import Routes from "@/modules/routes";
import { useEditorStore, ViewMode } from "@/stores/editor_store";


interface HeaderProps {
  currentPersistentStore?: any;
}

const props = defineProps<HeaderProps>();
const store = useEditorStore();

const emit = defineEmits<{
  (e: "toggleCompareBefore"): void;
  (e: "toggleCompareAfter"): void;
}>();

const toggleCompareBefore = () => {
  emit("toggleCompareBefore");
};

const toggleCompareAfter = () => {
  emit("toggleCompareAfter");
};

</script>

<style scoped>
.custom-gap {
  gap: 8px;
}
  @media(max-width: 345px) {
    .header-wrapper {
      flex-direction: column;
    }
  }
  @media(max-width: 375px) {
    .custom-gap {
      gap: 0;
    }
  }
</style>
